import { ICON_SELECTOR } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { colors, s16, s4, s8 } from '@ardoq/design-tokens';
import styled, { css } from 'styled-components';
import { caption, header2, header3 } from '@ardoq/typography';
import {
  IslandSectionContainer,
  SPACING_LOOKUP,
} from './IslandSectionContainer';

export const IslandHeaderBody = styled.div`
  flex: 1;
`;

export const IslandHeaderTitle = styled.div<{ $preventIconChange?: boolean }>`
  ${header2};
  display: flex;
  align-items: center;

  ${props =>
    !props.$preventIconChange &&
    css`
      ${ICON_SELECTOR} {
        color: ${colors.icon};
        &:first-child {
          margin-right: ${s8};
        }
        &:last-child {
          margin-left: ${s4};
        }
      }
    `}
`;

export const IslandHeaderTitlePlaceholder = styled.div`
  ${header2};
  user-select: none;
  color: ${colors.textSubtle};
`;

export const IslandSubheaderTitle = styled.div`
  ${header3};
  color: ${colors.textModerate};
`;

// For now we're going ahead with width from a selected list
// Todo: In the future we need to change Island footprint to
// make it more rebust to fit more use cases
export type SubtitleWidth = 'default' | 'medium' | 'large';

const tokenToWidth = {
  default: '540px',
  medium: '720px',
  large: '1020px',
};

export const IslandHeaderSubtitle = styled.div<{
  $subtitleWidth?: SubtitleWidth;
}>`
  ${caption};
  color: ${colors.textSubtle};
  max-width: ${({ $subtitleWidth = 'default' }) =>
    tokenToWidth[$subtitleWidth]};
`;

export const IslandHeaderTagsWrapper = styled(FlexBox).attrs({ gap: 'small' })`
  margin-bottom: ${s16};
  &:empty {
    display: none;
  }
`;

export const IslandHeaderWrapper = styled(IslandSectionContainer).attrs({
  flexDirection: 'row',
  align: 'center',
})<{ $skipVerticalPadding?: boolean; $hasColorBar?: boolean }>`
  display: block;
  width: 100%;
  padding: ${({ $skipVerticalPadding, $spacing = 'medium' }) =>
    $skipVerticalPadding
      ? `0 ${SPACING_LOOKUP[$spacing]}`
      : SPACING_LOOKUP[$spacing]};
  ${props =>
    props.$hasColorBar &&
    css`
      padding-left: ${s8};
      border-bottom: 0;
    `}
  ${IslandHeaderSubtitle} {
    margin-top: ${s4};
  }
`;

export const IslandSubheaderWrapper = styled(FlexBox).attrs({
  align: 'center',
  gap: 'medium',
})`
  ${IslandHeaderSubtitle} {
    margin-top: ${s8};
  }
`;
